<template>
	<div class="managerFilterWrapper">
		<div class="optionsTabDiv">
			<div class="lcpCard">
				<div class="inner" :class="slideInner">
					<span class="filterTitle" @click="show('filter')">Options</span>
					<div class="underline"><div class="underlineColour" :class="hightlightPosition"></div></div>
					<div class="slideWrapper" :class="slide">
						<div class="filterDiv">
							<dropdownInput
								title="General Ordering"
								:options="orderOptions"
								index="0"
								mutationRef="ManagerGeneralOrder"
								:presetValue="resetValue"
								@input="updateManagers"
							/>
							<!-- <rankingInput title="Score Filter" :options="orderOptions" maxOptions=3 index=1 /> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="returnWrapper">
			<div class="lcpCard">
				<div class="return">
					<div class="animated">
						<h2>Tests Table</h2>
						<div class="btn" @click="showTableView">Return</div>
						<img class="selection-img" v-bind:src="returnImg" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// // import eXcYteD3 from '@/components/eXcYteD3.js';
import dropdownInput from '@/components/common/uiInputs/dropdownInput.vue';
// import rankingInput from '@/components/common/uiInputs/rankingInput.vue';
import returnImg from '@/assets/svg/return.png';

export default {
    components: {
        dropdownInput,
        // rankingInput
    },
    data () {
        return {
            filterArray: [],
            mainHeight: 0,
            resetValue: 'Rating',
            showDimensions: false,
            showFilters: true,
            returnImg,
        };
    },
    computed: {
        orderOptions () {
            const ret = [];
            for (const n in this.$store.state.universe.data.valueDimensions) {
                if (this.$store.state.universe.data.valueDimensions[n].name !== 'None') {
                    ret.push(this.$store.state.universe.data.valueDimensions[n].name);
                }
            }
            ret.push('Asset class');
            return ret;
        },
        categoryOptions () {
            const ret = [];
            for (const n in this.$store.state.universe.data.categoryDimensions) {
                ret.push(this.$store.state.universe.data.categoryDimensions[n].name);
            }
            return ret;
        },
        hightlightPosition () {
            return this.showFilters ? '' : 'right';
        },
        slide () {
            return this.showFilters ? 'slideLeft' : 'slideRight';
        },
        slideInner () {
            return this.$store.state.ui.dropdownSelected ? 'slideUp' : '';
        },
    },
    methods: {
        show (view) {
            if (view === 'filter') {
                this.showFilters = true;
                this.showDimensions = false;
            }
            if (view === 'dimensions') {
                this.showFilters = false;
                this.showDimensions = true;
            }
        },
        // Show the reload button for the respective index at a specific dimension
        resetButton (index, dimension) {
            if (dimension === 'value') {
                this.$set(this.sliderBool, index, true);
                if (this.sliderResetClicked) {
                    this.$set(this.sliderBool, index, false);
                    this.$set(this.sliderPanelsShow, index, true);
                }
                this.sliderResetClicked = false;
            } else if (dimension === 'category') {
                this.$set(this.catDimBool, index, true);
                if (this.selectAllClicked) {
                    this.$set(this.catDimBool, index, false);
                    this.$set(this.categoryPanelsShow, index, true);
                }
                this.selectAllClicked = false;
            }
        },
        // updates the slider values when sliders are moved
        sliderFilter (newValue, sliderNumber) {
            this.data.valueFilter[sliderNumber].values[0] = newValue[0];
            this.data.valueFilter[sliderNumber].values[1] = newValue[1];
            this.$store.commit('updateValueFilter', this.data.valueFilter);
            this.filterChart();
        },
        updateManagers (value) {
            this.$store.commit('ui/updateManagerGeneralOrder', value.options);
        },
        showTableView () {
            this.$store.commit('backToTestsTable');
        },
    },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/all.scss";
.managerFilterWrapper {
	display: flex;
	flex-direction: column;
	.optionsTabDiv {
		overflow: hidden;
		flex-grow: 1;
		flex-basis: 0;
		position: relative;
		margin-bottom: 20px;
		.filterTitle {
			float: left;
			font-size: 18px;
			cursor: pointer;
		}
		.dimensionsTitle {
			float: right;
			font-size: 18px;
			cursor: pointer;
		}
		.underline {
			height: 2px;
			width: 100%;
			background-color: $grey;
			float: left;
			margin: 5px 0 0 0;
			position: relative;
			.underlineColour {
				height: 3px;
				width: 30%;
				background: $darkBlue;
				position: absolute;
				top: 0px;
				left: 0;
				@include easeInOut(1s);
				&.right {
					left: 70%;
				}
			}
		}
		.inner {
			@include easeInOut(0.5s);
			bottom: 10px;
			left: 20px;
			margin-top: 0;
			overflow: hidden;
			position: absolute;
			right: 20px;
			top: 10px;
			&.slideUp {
				margin-top: -56px;
				min-height: 570px;
			}
		}
		.slideWrapper {
			float: left;
			width: 210%;
			position: relative;
			left: -100%;
			@include easeInOut(1s);
			margin-top: 20px;
			height: calc(100% - 60px);
			.filterDiv,
			.dimensionsDiv {
				width: 47.5%;
				position: absolute;
				height: 100%;
			}
			.filterDiv {
				left: 50%;
			}
		}
		.slideLeft {
			left: -105%;
		}
		.slideRight {
			left: 0;
		}
	}
	.returnWrapper {
		flex-grow: 1;
		flex-basis: 0;
		position: relative;
		.return {
			padding: 20px;
			.btn {
				margin-top: 20px;
			}
			.selection-img {
				width: 200px;
				float: right;
			}
		}
	}
}
</style>
